import styled from "styled-components";

export const ContainerDescriptionBottom = styled.div`
  display: flex;
  padding: 1rem;
`;

export const SpanDescription = styled.span`
  font-family: Inter;
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.5rem;
  text-align: center;

  color: ${({ theme }) => theme.checkoutOnePage.textColor};
`;
